import { render, staticRenderFns } from "./Monitoring-Management.vue?vue&type=template&id=33d062b8&scoped=true"
import script from "./Monitoring-Management.vue?vue&type=script&lang=js"
export * from "./Monitoring-Management.vue?vue&type=script&lang=js"
import style0 from "./Monitoring-Management.vue?vue&type=style&index=0&id=33d062b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d062b8",
  null
  
)

export default component.exports